import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const useAccountNavigationSectionStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    marginBottom: spacing(4),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  title: {
    color: hexToRGBA(TextColors.light, TextOpacities.light2),

    '&.MuiTypography-root': {
      margin: spacing(0, 0, 2),
    },
  },
  navItemWrapper: {
    marginBottom: spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));

export default useAccountNavigationSectionStyles;
